module.exports = __webpack_public_path__ + "static/img/icon_todolist_dark.a8c2f02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon_todolist_dark.png
// module id = 589
// module chunks = 1